import React from "react";
import { Card } from "react-bootstrap";

const ManageOrder = ({ order }) => {
  const { name, price, description, img, days } = order;
  return (
    <div className="col-md-4 p-2 container">
      <div className="card h-100" style={{ "max-width": "500px" }}>
        <div className="row g-0">
          <div className="col-md-4"></div>
          <Card.Img variant="top" src={img} />
          <Card.Body>
            <Card.Title>
              <h3>Place: {name}</h3>
            </Card.Title>
            <Card.Text>
              <h5>Offering Price: {price} Taka</h5>
            </Card.Text>
            <Card.Text>
              <h5>Days: {days}</h5>
            </Card.Text>
            <Card.Text>{description}</Card.Text>
          </Card.Body>
        </div>
      </div>
    </div>
  );
};

export default ManageOrder;
